const userState = {
  id: null,
  sid: null,
  geolocation: {},
}

export default userState
